export default __webpack_public_path__ + "static/Hatton-Light-a83de3fc3ab6d2470bea3b56cb650a71.woff2";